<template>
	<div class="middle-ware-wrapper">
		<div :class="icon"></div>
		<p class="middle-tips-font">{{midFont}}</p>
	</div>
</template>

<script>
export default {
	props: {
		icon: String,
		midFont: String
	}
}
</script>


// WEBPACK FOOTER //
// MidWare.vue?3d726fe6